import {
  WESTEROS_AUTHORIZATION_ENUM,
  WESTEROS_MICROSERVICES_ENUM,
  westerosQuery,
} from '@/helpers/westeros';
import { getSubmodulesUserEnrolledIn } from '@/store/queries/mamata.queries';

export class EnrolledSubmodulesService {
  static async getUserEnrolledSubmodules(courseId: string): Promise<string[]> {
    const enrolledSubmodules = await westerosQuery(
      WESTEROS_MICROSERVICES_ENUM.MAMATA,
      getSubmodulesUserEnrolledIn,
      { courseId },
      WESTEROS_AUTHORIZATION_ENUM.PROFILE,
    );

    const {
      data: {
        userSubmodules: { submodules },
      },
    } = enrolledSubmodules;

    return submodules;
  }
}
